import { render, staticRenderFns } from "./UserQuestions.vue?vue&type=template&id=41790d5f&scoped=true&"
import script from "./UserQuestions.vue?vue&type=script&lang=js&"
export * from "./UserQuestions.vue?vue&type=script&lang=js&"
import style0 from "./UserQuestions.vue?vue&type=style&index=0&id=41790d5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41790d5f",
  null
  
)

export default component.exports